{
  "name": "dictionary-service-frontend",
  "version": "22.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ncp src/assets/config/config-local.json src/assets/config/config.json && ng serve",
    "start:localWithTestingBe": "ncp src/assets/config/config-testing.json src/assets/config/config.json && ng serve",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "test": "jest --ci --silent --maxWorkers=50%",
    "test:ci": "node --expose-gc ./node_modules/.bin/jest --ci --silent --maxWorkers=20%",
    "test:coverage": "jest --coverage",
    "lint": "ng lint",
    "format:fix": "pretty-quick --staged",
    "commit": "git add . && npx git-cz",
    "update:icons": "npx copy-lib-icons icons.config.js",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@akelius-edu/edu-user": "^0.1.2",
    "@akelius-edu/platforms-ui": "1.2.15",
    "@akelius-edu/shared-components": "1.3.20",
    "@akelius-edu/shared-core": "1.1.1",
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "22.2.6",
    "@angular/cdk-experimental": "22.2.6",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@auth0/auth0-spa-js": "^1.9.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^3.0.1",
    "@ngxs/devtools-plugin": "^22.0.0",
    "@ngxs/form-plugin": "^22.0.0",
    "@ngxs/logger-plugin": "^22.0.0",
    "@ngxs/storage-plugin": "^22.0.0",
    "@ngxs/store": "^22.0.0",
    "@sentry/angular": "^11.10.0",
    "file-saver": "^2.0.5",
    "jwt-decode": "^3.1.2",
    "ngx-scanner-qrcode": "1.7.6",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^21.0.4",
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "19.8.0",
    "@angular-eslint/template-parser": "19.8.0",
    "@angular/build": "^22.2.6",
    "@angular/cli": "^22.2.6",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@types/jest": "29.5.14",
    "@types/node": "^24.19.1",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "eslint": "8.57.1",
    "husky": "^9.1.7",
    "jest": "29.7.0",
    "jest-preset-angular": "14.6.0",
    "ncp": "2.0.0",
    "prettier": "^3.5.3",
    "pretty-quick": "^4.2.2",
    "ts-jest": "^29.4.0",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.3"
  }
}
